<template>
  <!-- 分享-个人中心 -->
  <div class="userCenterWarp">
      <v-shareFooter :content="shareSwiper"></v-shareFooter>
      <v-shareSuccessBack :show="showShareBack"></v-shareSuccessBack>
      <div class="header">
          <div class="imgDiv">
              <div class="img">
                <img :src="detail.headImage" alt="">                 
              </div>
          </div>
          <p class="name">{{detail.userName}}</p>
          <p class="number">
              <span class="follow">关注 <i>{{detail.followTotal}}</i>|</span><span class="fans">粉丝 <i>{{detail.fabulousTotal}}</i></span>
          </p>
          <p class="company">
              <span>{{detail.companyName}}</span>　<span>{{detail.positionName}}</span>
          </p>
      </div>
      <div class="titleType">
            <span @click="tabTitle(item.typeNum)" v-for="item in typeList" :class="titleTypeNum == item.typeNum ? 'on':''">
              {{item.typeName}}<i v-show="titleTypeNum == item.typeNum" class="line"></i>
            </span>
      </div>
      <div class="homePage" v-if="titleTypeNum == 1">
          <!-- 擅长领域 -->
          <div class="territory" v-if="userData.professionalAblity">
              <div class="title"><img src="../images/usericon1.png" alt="">专业能力</div>
              <div class="content">
                <span v-for="item in userData.professionalAblity">{{item}}</span>
              </div>
          </div>
          <div class="lineDiv" v-if="!userData.professionalAblity"></div>
          <!-- 关于我 -->
          <div class="aboutMe">
              <div class="title"><img src="../images/usericon2.png" alt="">关于我</div>
              <ul class="aboutMeUl">
                    <li v-if="userData.cityName">
                        <div class="label">任职公司</div>
                        <div class="info">{{userData.cityName}}</div>
                    </li>
                    <li v-if="userData.domainName">
                        <div class="label">所在领域</div>
                        <div class="info">{{userData.domainName}}</div>
                    </li>
                    <li v-if="userData.cityName">
                        <div class="label">所在城市</div>
                        <div class="info">{{userData.cityName}}</div>
                    </li>
                    <li v-if="userData.introduce">
                        <div class="label block">自我介绍</div>
                        <div class="data">{{userData.introduce}}</div>
                    </li>
                    <li v-if="userData.imageAddr">
                        <div class="label">公司产品</div>
                        <div class="info imgData">
                            <img @click="toStore" v-for="item in userData.imageAddr" :src="item+'?x-oss-process=image/crop,x_0,y_0,w_500,h_500,g_center'" alt="">
                        </div>
                    </li>
              </ul>
              <!-- <div class="content">{{userData.introduce}}</div> -->
          </div>
      </div>
      <!-- 文章 -->
      <div class="userArticle" v-if="titleTypeNum == 2">
          <ul class="contentUl" v-if="reportList.length != 0">
              <li class="li" v-for="(item,index) in reportList" @click="toStore">
                  <p class="title"><span>{{item.serialNo}}</span>{{item.title}}</p>
                  <p class="time">{{item.createTime}}</p>
                  <p class="icon">
                      <span><img src="../images/icon2.png" alt="">{{item.readTotal}}</span>
                      <span><img src="../images/icon3.png" alt="">{{item.fabulousTotal}}</span>
                      <span><img src="../images/icon1.png" alt="">{{item.commentTotal}}</span>
                  </p>
              </li>
          </ul>
          <div class="noData" v-else>
                <img src="../images/noData.png" alt="">
                <p>暂无数据</p>           
          </div>
      </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import '../js/flexible.debug.js'
import global from "../js/global.js"
import weixin from "../js/weixinall.js"
export default {
  data () {
    return {
        titleTypeNum:1,
        typeList:[
            {
                typeName:'主页',
                typeNum:1
            },
            {
                typeName:'文章',
                typeNum:2
            }
        ],
        detail: '',//页面基础数据
        userData:'',
        reportList:[],
        shareSwiper:'',
        showShareBack:false,//分享成功弹窗提示状态
    }
  },
  created(){
    this.init();
  },
  mounted(){
    weixin.shareInfo(14,this.$route.query.loginAccountId,this.$route.query.accountId)
    weixin.shareTitle(14,this.$route.query.accountId,(data)=>{
      this.shareSwiper = data;
    });
  },
  methods:{
    toStore(){
      global.toStore(this.shareSwiper)
    },
    init(){
        this.$http.get("account/thrid/query?accountId="+this.$route.query.accountId)
        .then((response) => {
            this.detail = response.respData.accountBase;
            this.userData = response.respData.userDetail;
        });
        //查询文章
        this.$http.get("account/thrid/query/report?start="+1+"&end="+10+"&accountId="+this.$route.query.accountId+"&loginAccountId="+this.$route.query.loginAccountId,{headers:{"Authorization":"bearer 1"}})
        .then((response) => {
            this.reportList = response.respData.reportResult.bigShotReportList;
        });
    },
    tabTitle(type){//切换标签
        this.titleTypeNum = type;
    }
  }
}
</script>

<style scoped lang="less">
.userCenterWarp{
    background: #FBF6F6;
    margin-bottom: 88px;
    .header{
        width: 100%;
        height: 460px;
        background: url('../images/banner@2x.png') no-repeat;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
        .imgDiv{
            margin: 128px 0 20px 0;
            width: 100%;
            height: 144px;
            display: flex;
            justify-content: center;
            .img{
                width: 144px;
                height: 144px;
                border-radius: 50%;
                border: 2px solid #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
                img{
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }
        
        .name{
            font-size: 34px;
            line-height: 48px;
            color: #FFFFFF;
            text-shadow: 2px 2px 6px rgba(140,14,14,0.50);
            text-align: center;
        }
        .number{
            text-align: center;
            color: #fff;
            margin-bottom: 8px;
            i{
                font-weight: bold;
                font-style: normal;
                font-size: 26px;
                margin-left: 24px;                
            }
            span{
                display: inline-block;
                width: 50%;
            }
            .follow{
                text-align: right;
                i{
                    margin-right: 46px;
                }
            }
            .fans{
                text-align: left;
                text-indent: 46px;
            }
        }
        .company{
            text-align: center;
            line-height: 36px;
            font-size: 26px;
            color: #CBAC7A;
            text-shadow: 2px 2px 6px rgba(140,14,14,0.50);
        }
    }
    .titleType{
        position: relative;
        z-index: 2;
        width: 100%;
        height: 80px;
        line-height: 80px;
        font-size: 28px;
        color: #333440;
        display: flex;
        background: #FFFFFF;
        box-shadow: 0 4px 5px 0 rgba(0,0,0,0.05);
        text-align: center;
        .on{
            color: #EF4B4B;
        }
        span{
            flex:1;
            position: relative;
            i{
                position: absolute;
                left: 50%;
                margin-left: -16px;
                bottom: 8px;
                display: block;
                background: #EF4B4B;
                width: 32px;
                height: 4px;
            }
        }
    }
    .homePage{
        .territory{
            background: #fff;
            padding: 56px 30px 16px;
            .title{
                font-size: 28px;
                color: #333440;
                margin-bottom: 24px;
                img{
                    width: 32px;
                    height: 32px;
                    vertical-align: middle;
                    margin-right: 12px;
                }

            }
            .content{
                span{
                    display: inline-block;
                    padding: 7.6px 27px;
                    border-radius: 200px;
                    border: 2px solid #A4A4A4;
                    margin: 0 12px 12px 0;
                }
            }
        }
        .lineDiv{
            width: 100%;
            height: 20px;
            background: #FBF6F6;
        }
        .aboutMe{
            background: #fff;            
            .title{
                font-size: 28px;
                color: #333440;
                padding: 32px 30px 20px;
                border-bottom: 2px solid  #EFEFEF;
                img{
                    width: 32px;
                    height: 32px;
                    vertical-align: middle;
                    margin-right: 12px;
                }
            }
            .aboutMeUl{
                li{
                    overflow: hidden;
                    width: 100%;
                    border-bottom: 1px solid #EFEFEF;
                    .label{
                        float: left;
                        width: 174px;
                        height: 88px;
                        line-height: 88px;
                        font-size: 30px;
                        color: #333440;
                        text-align: center;
                        font-weight: 600;
                    }
                    .info{
                        float: right;
                        width: 568px;
                        line-height: 42px;
                        padding: 24px 30px 22px 0;
                        font-size: 30px;
                        color: #333440;
                    }
                    .imgData{
                        padding: 24px 20px 22px 0;
                        img{
                            width: 172px;
                            height: 172px;
                            margin: 0 10px 10px 0;
                        }
                    }
                    .block{
                        float: none;
                    }
                    .data{
                        padding: 14px 30px 28px 30px;
                        font-size: 28px;
                        color: #5B5C66;
                        letter-spacing: 0.4px;
                        line-height: 48px;
                    }
                }
            }
            .content{
                padding: 14px 30px 28px 30px;
                font-size: 26px;
                color: #5B5C66;
                letter-spacing: 0.4px;
                line-height: 48px;
            }
        }
    }
    .userArticle{
        overflow: hidden;
        .contentUl{
            background-color:#FBF6F6;
            .li{
                background-color:#fff;
                padding: 36px 30px 12px 22px;
                margin-bottom: 20px;                
                .title{
                    line-height: 42px;
                    font-size: 30px;
                    color: #333440;
                    span{
                        display: inline-block;
                        border-radius: 100%;
                        font-size: 24px;
                        color: #FFFFFF;
                        margin-right: 8px;
                        background: #EF4B4B;
                        padding: 0 14px;
                        vertical-align: text-bottom;
                    }
                }
                .time{
                    margin: 8px 0 24px 0;
                    font-size: 22px;
                    line-height: 32px;
                    color: #A4A4A4;
                    margin-left: 46px;
                }
                .icon{
                    text-align: right;
                    font-size: 22px;
                    color: #A4A4A4;
                    span{
                        margin-left: 36px;
                    }
                    img{
                        max-width: 44px;
                        max-height: 40px;
                        vertical-align: middle;
                        margin-right: 12px;
                    }
                }
            }
        }
        .noData{
            text-align: center;
            background: #fff;
            padding-top: 80px;
            text-align: center;
            font-size: 36px;
            color: #999;
            img{
                width: 164px;
                height: 164px;
                margin-bottom: 20px;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/share/shareuserCenter.vue